import React, { Fragment } from "react";
import styles from "./Layout.module.css";
import { Box, useMediaQuery } from "@mui/material";
import Header from "./header/Header";
import { MobileFooter } from "./footer/MobileFooter";
import { useLocation } from "react-router-dom";

export const Layout = ({ children }: any) => {
  const location: any = useLocation();
  const isMobile = useMediaQuery("(max-width: 839px)");
  return (
    <Fragment>
      {!isMobile ?
        <Header />
        : ''
      }
      <div className={styles["main-container"]}>{children}</div>
      {isMobile ?
        <Box
          sx={{
            display: { xs: "block", sm: "block", md: "none", lg: "none" },
          }}
        >
          {location.pathname === "/upload/create-project" || location.pathname === "/upload/create-post" || location.pathname.includes("event-details") ? null : <MobileFooter />}
        </Box>
        : ''
      }
    </Fragment>
  );
};
